import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedWrapper = ({ children }) => {
  const authData = localStorage.getItem("auth");
  if (authData) {
    return children;
  } else {
    return <Navigate to={"/"} />;
  }
};

export default ProtectedWrapper;
